import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ObjectStatusCssClasses, ObjectStatusTitles } from "../ObjectsUIHelpers";
import * as actions from "../../../../../../app/actions/generalActions";
import { useObjectsUIContext } from "../ObjectsUIContext";
import { FormattedMessage, useIntl } from "react-intl";
import { useFilterObjectsUIContext } from "../FilterObjectsUIContext";
import { ShowToast, ToastType } from "../../../../../_helpers/ToastHelpers";
import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
// import { utils } from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";

export const AuditFormResultDialog = ({ show, onHide, id, currentState, api }) => {

  const { isLoading, objectForEdit } = useSelector(
    (state) => ({
      isLoading: currentState.actionsLoading,
      objectForEdit: currentState.objectForEdit,
    }),
    shallowEqual
  );
  const { name } = currentState;

  const { answerState } = useSelector(
    (state) => ({ answerState: state.answerQuestions }),
    shallowEqual
  );
  const [header, setHeader] = useState("ثبت پاسخ");
  const [answers, setAnswers] = useState([]);
  const [answerEntered, setAnswerEntered] = useState("");
  const [answerSelected, setAnswerSelected] = useState(0);

  const [selectedDay, setSelectedDay] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchObject(api, name, id))
  }, [id, dispatch]);

  useEffect(() => {

    if (objectForEdit && objectForEdit.questionId) {
      var query = {
        whereClause: "",
        whereClauseParameters: [],
        orderClause: "id asc ",
        skipCount: 0,
        takeCount: 1000,
      }
      setHeader(objectForEdit.questionTitle)
      query.whereClause = "questionId=@0"
      query.whereClauseParameters.push(objectForEdit.questionId)
      dispatch(actions.fetchObjects("api/AnswerOfQuestion", "answerQuestions", query))
    }
  }, [objectForEdit]);



  const saveAnswer = () => {
    var saveValues = { ...objectForEdit }
    saveValues.status = "Temp"
    if (saveValues.answerType === 2) {
      if (answerSelected > 0) {
        saveValues.answerOfQuestionId = answerSelected
        saveValues.enteredAnswer = answerState.entities.find(q => q.id === answerSelected).answerTitle
      }
      else {
        ShowToast("لطفا جواب را انتخاب نمایید.", ToastType.warning)
        return
      }
    }
    else if (saveValues.answerType === 4) { //datePicker
      if (selectedDay) {
        saveValues.answerOfQuestionId = 8
        let utcDate = moment(`${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`, "jYYYY/jM/jD");
        saveValues.enteredAnswer = utcDate.format("jYYYY/jMM/jDD");
      }
      else {
        ShowToast("لطفا جواب را انتخاب نمایید.", ToastType.warning)
        return
      }
    }
    else {
      if (answerEntered != "") {
        saveValues.answerOfQuestionId = 8
        saveValues.enteredAnswer = answerEntered
      }
      else {
        ShowToast("لطفا جواب را وارد نمایید.", ToastType.warning)
        return
      }
    }

    dispatch(actions.updateObject(api, name, saveValues)).then(() => {
      // ShowToast("پاسخ شما ذخیره شد. توجه داشته باشید که پاسخ های شما تا زمانی که تمام پرسش ها را تکمیل کرده و دکمه تایید نهایی تکمیل پرسشنامه را بزنید به صورت تایید نشده خواهد بود.", ToastType.info)
      setAnswerEntered("")
      setAnswerSelected(0)
      setSelectedDay(null)
      onHide()

    });

  };

  const handleChangeSelected = (e) => {
    setAnswerSelected(+e.target.value)
  }

  const handleChangeEntered = (e) => {
    setAnswerEntered(e.target.value)
  }

  const handleChangeDatepickerValue = ({ val }) => {
    let utcDate = null;
    utcDate = moment(`${val.year}/${val.month}/${val.day}`, "jYYYY/jM/jD");
    let newValue = utcDate.format("YYYY-MM-DD");
    setAnswerEntered(newValue);
    setSelectedDay();
  };


  const intl = useIntl();
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {header}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block cursor-default">
        {isLoading && (
          <div className="overlay-layer bg-transparent">
            <div className="spinner spinner-lg spinner-warning" />
          </div>
        )}

        {objectForEdit && objectForEdit.enteredAnswer !== "" &&
          <div className="form-group">
            <label className="mr-3">پاسخ ثبت شده  : </label>
            <label>{objectForEdit && objectForEdit.enteredAnswer} </label>
          </div>
        }


        {objectForEdit &&
          objectForEdit.answerType === 1 &&
          <div className="form-group">
            {objectForEdit && objectForEdit.enteredAnswer !== "" &&
              <label>اگر قصد ویرایش پاسخ را دارید پاسخ جدید را وارد کرده و دکمه تایید را بزنید تا با پاسخ ثبت شده جایگزین شود</label>
            }
            {objectForEdit && objectForEdit.enteredAnswer === "" &&
              <label>پاسخ  </label>
            }

            <input
              className="form-control"
              type="text"
              value={answerEntered}
              onChange={handleChangeEntered}
            />
            <small className="form-text text-muted">
              برای ثبت پاسخ لطفا مقدار تشریحی مورد نظر خود را وارد کرده و گزینه تایید را بزنید
            </small>
          </div>
        }
        {objectForEdit &&
          objectForEdit.answerType === 2 &&
          <div className="form-group">
            {objectForEdit && objectForEdit.enteredAnswer !== "" &&
              <label>اگر قصد ویرایش پاسخ را دارید پاسخ جدید را وارد کرده و دکمه تایید را بزنید تا با پاسخ ثبت شده جایگزین شود</label>
            }
            {objectForEdit && objectForEdit.enteredAnswer === "" &&
              <label>پاسخ  </label>
            }
            <select
              className={`form-control`}
              value={answerSelected}
              onChange={handleChangeSelected}
            >
              <option key={0} value={0}>لطفا انتخاب کنید</option>
              {answerState.entities && answerState.entities.map((object) => (
                <option key={object.id} value={object.id}> {object.questionTitle}  {object.answerTitle}</option>
              ))}

            </select>
            <small className="form-text text-muted">
              برای ثبت پاسخ از میان گزینه های موجود را یکی را انتخاب و گزینه تایید را بزنید
            </small>
          </div>}

        {objectForEdit &&
          objectForEdit.answerType === 3 &&
          <div className="form-group">
            {objectForEdit && objectForEdit.enteredAnswer !== "" &&
              <label>اگر قصد ویرایش پاسخ را دارید پاسخ جدید را وارد کرده و دکمه تایید را بزنید تا با پاسخ ثبت شده جایگزین شود</label>
            }
            {objectForEdit && objectForEdit.enteredAnswer === "" &&
              <label>پاسخ  </label>
            }
            <input
              className="form-control"
              type="number"
              min="0"
              value={answerEntered}
              onChange={handleChangeEntered}
            />
            <small className="form-text text-muted">
              برای ثبت پاسخ لطفا مقدار عددی مورد نظر خود را وارد کرده و گزینه تایید را بزنید
            </small>
          </div>
        }

        {objectForEdit &&
          objectForEdit.answerType === 4 &&
          <div className="form-group">
            {objectForEdit && objectForEdit.enteredAnswer !== "" &&
              <label>اگر قصد ویرایش پاسخ را دارید پاسخ جدید را وارد کرده و دکمه تایید را بزنید تا با پاسخ ثبت شده جایگزین شود</label>
            }
            {objectForEdit && objectForEdit.enteredAnswer === "" &&
              <label>پاسخ  </label>
            }
            <DatePicker
              locale={"fa"}
              isRtl={true}
              value={selectedDay}
              onChange={setSelectedDay}
              shouldHighlightWeekends
              inputClassName="form-control"
              // formatInputText="jYYYY/jM/jD"
              // renderInput={renderCustomInput} // render a custom input
              calendarClassName="responsive-calendar"
            />
            <small className="form-text text-muted">
              برای ثبت پاسخ لطفا تاریخ مورد نظر خود راانتخاب کرده و گزینه تایید را بزنید
            </small>
          </div>}

        {objectForEdit &&
          objectForEdit.answerType === 5 &&
          <div className="form-group">
            {objectForEdit && objectForEdit.enteredAnswer !== "" &&
              <label>اگر قصد ویرایش پاسخ را دارید پاسخ جدید را وارد کرده و دکمه تایید را بزنید تا با پاسخ ثبت شده جایگزین شود</label>
            }
            {objectForEdit && objectForEdit.enteredAnswer === "" &&
              <label>پاسخ  </label>
            }
            <input
              className="form-control"
              type="number"
              min="1"
              value={answerEntered}
              onChange={handleChangeEntered}
            />
            <small className="form-text text-muted">
              برای ثبت پاسخ لطفا مقدار مورد نظر خود را وارد کرده و گزینه تایید را بزنید
            </small>
          </div>
        }
      </Modal.Body>
      <Modal.Footer className="form">
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={saveAnswer}
            className="btn btn-primary btn-elevate"
          >
            تایید
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
